<template>
    <v-layout row wrap class="p-3">
        <v-flex xs12 sm3 v-for="(item,index) in selected_pages" :key="index">
            <v-hover>
                <v-card slot-scope="{hover}" :class="isMobile?`menu-card-mobile elevation-${hover?3:1}`:`menu-card elevation-${hover?3:1}`">
                    <v-toolbar flat height="40">
                        <span class="body-2 page-header" :class="hover?'primary--text':''" @click="navigateToPage(item.pagePath)">
                            {{item.pageName}}
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="updateFavorite(item)">
                            <v-icon v-if="item.favorite" color="primary" :title="`Remove ${item.pageName} from favorites`">bookmark</v-icon>
                            <v-icon v-else color="grey" :title="`Add ${item.pageName} to favorites`">bookmark_add</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text xs12 class="caption menu-body" :class="hover?'primary--text':'grey--text text--darken-1'" @click="navigateToPage(item.pagePath)">
                        <v-layout row wrap>
                            <v-flex xs3>
                                <v-icon size="40" class="mr-1" :color="hover?'primary':''" :style="isMobile?'margin-left:15px;':'margin-left:5px;'">{{item.pageIcon}}</v-icon>
                            </v-flex>
                            <v-flex xs9>
                                <div class="menu-description">
                                    {{item.pageDescription}}
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-flex>
        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{alertMsg}}
            <v-btn color="primary" flat @click="snackbar=false">Close</v-btn>
        </v-snackbar>
    </v-layout>
</template>
<script>

import appsApi from '@/api/applications'
export default {
    data() {
        return {
            error: false,
            errorMsg: null,
            snackbar: false,
            mode: null,
            x: null,
            y: null,
            alertMsg: null
        }
    },
    props: ['app_id'],
    methods: {
        async updateFavorite(item) {
            try{
                const added = !item.favorite
                const data = {
                    appPageId: item.appPageId,
                    added: added
                }
                const response = await appsApi.updateFavorite(data)
                if (response && response.status == 200) {
                    const action = added ? 'added to' : 'removed from'
                    this.alertMsg = `${item.pageName} has been ${action} your favorites.`
                    this.snackbar = true
                    this.updateAppsList(item.appPageId, added)
                }
            }catch(error){
                this.error = true
                this.errorMsg = error
            }
        },
        updateAppsList(appPageId, added) {
            var updated_apps_list = this.$store.state.user_apps_list;
            let app = updated_apps_list.find(item => item.appId == this.app_id);
            if (app) {
                let page = app.appPages.find(page => page.appPageId == appPageId);
                if (page) {
                    page.favorite = added;
                }
            }
            this.$store.commit('setUserAppsList', updated_apps_list)
        },
        navigateToPage(path){
            this.$router.push(path)
        }
    },
    computed: {        
        selected_pages() {
            if (this.$store.state.user_apps_list) {
                const app = this.$store.state.user_apps_list.find(x => x.appId == this.app_id)
                return app ? app.appPages : []
            }
            return []
        },
    },
}
</script>
<style scoped>
.menu-description {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: -10px;
}
.menu-body:hover {
    cursor: pointer;
    text-decoration: underline;
}
.menu-card {
    height: 130px;
    overflow: hidden; 
    margin: 2px 2px 0px 2px; 
    border-radius: 5px
}
.menu-card-mobile {
    height: 110px;
    overflow: hidden; 
    margin: 3px 5px 0px 5px; 
    border-radius: 5px;
}
.page-header:hover {
    cursor: pointer;
    text-decoration: underline;
}
</style>